(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('ProjectTypeDeleteController',ProjectTypeDeleteController);

    ProjectTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProjectType'];

    function ProjectTypeDeleteController($uibModalInstance, entity, ProjectType) {
        var vm = this;

        vm.projectType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProjectType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
